import React, { useEffect } from "react";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { DropdownCustomToggler } from "../../../_metronic/_partials/dropdowns";
import ModalLayoutWithDelete from "../Dialogs/ModalLayoutWithDelete";
import { AESVG } from "../svg";

//controls the users comments
const FeedActions = ({
  canUpdate,
  feedId,
  actions,
  getEntity,
  setEditFeed,
  setSelectedFeed,
  isAuthor,
}) => {
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [idForDelete, setIdForDelete] = useState(null);
  const dispatch = useDispatch();
  const openDeleteDialog = (id) => {
    setIdForDelete(id);
    setDeleteModalShow(true);
  };
  const closeDeleteDialog = () => {
    setIdForDelete(null);
    setDeleteModalShow(false);
  };
  const { formatMessage } = useIntl();
  const deleteEntity = (feedId) => {
    dispatch(actions.deleteEntity(feedId)).then(() => getEntity());
    closeDeleteDialog();
  };
  const EditFeed = (feedId) => {
    setEditFeed(true);
    setSelectedFeed(feedId);
  };
  useEffect(() => {
    // console.log({ isAuthor, canUpdate });
  }, []);

  const canEdit = isAuthor && canUpdate;
  return canUpdate ? (
    <div className="">
      <Dropdown>
        <Dropdown.Toggle as={DropdownCustomToggler}>
          <AESVG size={"lg"} path={"/General/Settings-1.svg"} />
        </Dropdown.Toggle>
        <Dropdown.Menu
          className="dropdown-menu dropdown-menu-sm dropdown-menu-left"
          // as={OverlayDropdownMenu}
        >
          {canEdit && (
            <Dropdown.Item
              onClick={() => {
                EditFeed(feedId);
              }}
            >
              {formatMessage({ id: "EDIT" })}
            </Dropdown.Item>
          )}
          <Dropdown.Item
            onClick={() => {
              openDeleteDialog(feedId);
            }}
          >
            {formatMessage({ id: "DELETE" })}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <ModalLayoutWithDelete
        closeDeleteDialog={closeDeleteDialog}
        deleteModalShow={deleteModalShow}
        title="Comment"
        deleteEntity={deleteEntity}
        idForDelete={idForDelete}
      />
    </div>
  ) : (
    <></>
  );
};

export default FeedActions;
